// test1136
(1136 && 0);
